import { statuses, sumValues } from '@/core';
import deepCopy from 'deepcopy';
import moment from 'moment';

export default function createTripOrder(order) {
	return {
		id: order.id,
		orderId: order.orderId ? order.orderId : order.id,
		orderNumber: order.orderNumber,
		accepted: false,
		additionalReferences: deepCopy(order.additionalReferences),
		chargableWeight: sumValues(order.freightLines, 'chargableWeight'),
		clerk: deepCopy(order.clerk),
		consignee: deepCopy(order.consignee),
		consigneeReference: order.consigneeReference,
		consignor: deepCopy(order.consignor),
		createdAt: moment.utc().valueOf(),
		customer: deepCopy(order.customer),
		customersReference: order.customersReference,
		deliveryOption: 'deliveryParty',
		deliveryParty: deepCopy(order.deliveryParty || order.consignee),
		despatchOption: 'despatchParty',
		despatchParty: deepCopy(order.despatchParty || order.consignor),
		deviation: deepCopy(order.deviation),
		eta: deepCopy(order.eta),
		etd: deepCopy(order.etd),
		finalDeliveryParty: order.finalDeliveryParty ? deepCopy(order.finalDeliveryParty) : deepCopy(order.deliveryParty),
		freightLines: deepCopy(order.freightLines),
		goodsType: deepCopy(order.goodsType),
		grossWeight: sumValues(order.freightLines, 'grossWeight'),
		internalNotes: order.internalNotes,
		loadingMeters: order.loadingMeters,
		loadingSequenceNo: order.loadingSequenceNo,
		mayGenerateReturnOrder: order.mayGenerateReturnOrder,
		numberOfPackages: order.numberOfPackages,
		numberOfPallets: sumValues(order.freightLines, 'numberOfPallets'),
		orderType: deepCopy(order.orderType),
		originalDespatchParty: order.originalDespatchParty ? deepCopy(order.originalDespatchParty) : deepCopy(order.despatchParty),
		originalShipper: order.originalShipper ? deepCopy(order.originalShipper) : deepCopy(order.consignor),
		packages: deepCopy(order.packages),
		poReference: order.poReference,
		registeredDate: deepCopy(order.registeredDate),
		sendersReference: order.sendersReference,
		economicalStatus: statuses.economical.settled,
		status: statuses.order.planned,
		transporterInstructions: order.transporterInstructions,
		volume: sumValues(order.freightLines, 'volume'),
		waybillNumber: order.waybillNumber,
		next: deepCopy(order.next),
		prev: deepCopy(order.prev),
	};
}